import { type ObjectValuesUnionType } from '../utils/typing';

export const TournamentIds = Object.freeze({
  SOCCER_PREMIER_LEAGUE: 1,
  SOCCER_LIGUE_1_UBER_EATS: 4,
  SOCCER_MAJOR_LEAGUE_SOCCER: 18,
  SOCCER_CHAMPIONS_LEAGUE: 23,
  SOCCER_LIGA_MX_APERTURA: 28,
  SOCCER_SERIE_A: 33,
  SOCCER_LA_LIGA: 36,
  SOCCER_EREDIVISIE: 39,
  SOCCER_BUNDESLIGA: 42,
  SOCCER_LIGA_PORTURGAL: 52,
  SOCCER_INT_FRIENDLY_GAMES: 66,
  SOCCER_MLS_PLAYOFFS: 7048,
  SOCCER_EUROPA_LEAGUE: 10909,
  SOCCER_LIGA_MX: 16753,
  SOCCER_LIGA_MX_FINALS: 16754,
  SOCCER_LIGA_MX_FINALS_BIS: 16755,
});

export type TournamentId = number;

export const TopCompetitionLevels = Object.freeze({
  SPORT: 1,
  CATEGORY: 2,
});

export type TopCompetitionLevel = ObjectValuesUnionType<typeof TopCompetitionLevels>;
